if(!customElements.get('hoculus-redirect-modal')) {
    class HoculusRedirectModal extends HTMLElement {
        constructor() {
            super();
            this.matchingRedirect = this.dataset.matching
            this.inverseRedirect = this.dataset.inverseRedirect || null;
            
            this.leaveButton = this.querySelector('.redirect-modal__buttons a');
            this.stayButton = this.querySelector('.redirect-modal__buttons button');
        }

        connectedCallback() {
            this.init();
        }

        async init() {
            try {

                const dismissed = hoculus.Utils.getCookie('redirect_modal_dismissed');

                const response = await fetch(
                    window.Shopify.routes.root
                    + 'browsing_context_suggestions.json'
                    + '?country[enabled]=true'
                    + `&country[exclude]=${window.Shopify.country}`
                    + '&language[enabled]=true'
                    + `&language[exclude]=${window.Shopify.language}`
                );

                const browsingContextSuggestions = await response.json();

                const [key, ...valueParts] = this.matchingRedirect.split(':');
                const matchingObj = {[key]: valueParts.join(':')};

                const country = browsingContextSuggestions.detected_values.country.handle;

                if (dismissed === country) return;

                const shouldRedirect = this.inverseRedirect ? country !== key : country === key;
                const redirectUrl = this.inverseRedirect ? this.inverseRedirect : matchingObj[key];
                shouldRedirect && (this.setAttribute('open', 'true'),this.leaveButton.setAttribute('href', redirectUrl));

                this.stayButton.addEventListener('click', () => {
                    hoculus.Utils.setCookie('redirect_modal_dismissed', country, 30 * 24 * 60);
                    this.removeAttribute('open');
                });

            } catch (error) {
                console.error(error);
            }
        }
    }
    customElements.define('hoculus-redirect-modal', HoculusRedirectModal);
}